<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :showAdd="false"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: `vehicles/events`,
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('VEHICLE_TITLE')"
        width="120"
      >
        <template slot-scope="scope">
          <LicensePlate
            v-if="scope.row.vehicle"
            :vehicle="scope.row.vehicle.vehicle"
            :license_plate="scope.row.vehicle.license_plate"
            :chars="alphaList"
          />
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('EVENT_TYPE')"
        width="150"
      >
        <template slot-scope="scope">
          <div :data-title="$t('EVENT_TYPE')">
            {{
              scope.row.vehicle_event_type
                ? $i18n.locale == 'fa'
                  ? scope.row.vehicle_event_type.fa_title
                  : scope.row.vehicle_event_type.en_title
                : '-'
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TIME')"
        width="150"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TIME')" class="flex flex-col">
            <span>
              {{
                new Date(scope.row.start_datetime).toLocaleTimeString('fa-IR')
              }}
              |
              {{
                new Date(scope.row.start_datetime).toLocaleDateString('fa-IR')
              }}
            </span>
            <span v-if="scope.row.end_datetime">
              {{ new Date(scope.row.end_datetime).toLocaleTimeString('fa-IR') }}
              |
              {{ new Date(scope.row.end_datetime).toLocaleDateString('fa-IR') }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('COORDINATES')"
        width="150"
      >
        <template slot-scope="scope">
          <div :data-title="$t('COORDINATES')">
            <el-button
              type="text"
              class="text-carpo"
              @click="showLocation(scope.row.latitude, scope.row.longitude)"
              v-if="scope.row.latitude && scope.row.longitude"
            >
              {{ $t('VIEW') }}
            </el-button>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <customDialog
      v-if="showMap"
      :title="$t('COORDINATES')"
      childClass="info_msg"
      :show="showMap"
      :showFooter="false"
      customWidth="60%"
      :showClose="true"
      @show="showMap = $event"
      @confirmButn="showMap = false"
    >
      <div
        class="col-span-full mb-4"
        style="height: 60vh; width: 100%"
        ref="mapElement"
      ></div>
    </customDialog>
  </Content>
</template>

<script>
import { FleetEvents } from '@/api/reports'
import { licenseChars } from '@/api/global'
import LicensePlate from '@/components/cars/LicensePlate'
import customDialog from '@/components/elements/dialog'
import config from '@/configs/configs'

export default {
  components: {
    LicensePlate,
    customDialog,
  },
  data() {
    return {
      tableData: {
        results: [],
      },
      alphaList: [
        {
          char: '',
          code: '',
        },
      ],
      search: '',
      loading: true,
      showMap: false,
      map: null,
      marker: null,
      defaultCoordinate: [35.71343059526645, 51.407055307645365],
    }
  },

  mounted() {
    FleetEvents.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  methods: {
    showLocation(lat, lng) {
      const latitude = lat
      const longitude = lng

      this.showMap = true
      this.defaultCoordinate = [latitude, longitude]
      let this_ = this
      setTimeout(function () {
        this_.loadMap()
      }, 500)
      this.marker = null
      setTimeout(() => {
        this_.addMarker(this_.map, [latitude, longitude], false)
        this_.map.setView(new L.LatLng(latitude, longitude), 15)
      }, 700)
    },
    loadMap() {
      if (this.map) {
        this.map.remove()
        this.map = null
      }

      var map = L.map(this.$refs['mapElement'], { tap: false }).setView(
        this.defaultCoordinate,
        10
      )
      L.tileLayer(config.tile, {
        attribution: '@ Carpo',
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: config.leaflet,
      }).addTo(map)
      this.map = map
    },
    addMarker(map, corrdinate = this.defaultCoordinate, draggable = false) {
      if (this.marker) {
        map.removeLayer(this.marker)
      }

      var greenIcon = L.icon({
        iconUrl: '../../../pin.png',
        iconSize: [38, 38],
      })

      let marker = new L.marker(corrdinate, {
        draggable: draggable,
        icon: greenIcon,
      })
      this.marker = marker
      map.addLayer(marker)
    },
  },
}
</script>
